export class ResourceDetails {
    'id';
    'providerResourceId';
    'resourceName';
    'resourceType';
    'providerAccountId';
    'accountDisplayName';
    'cloudProvider';
    'region';
    'sourceStorageSizeBytes';
    'eonSnapshotCount';
    'lastSuccessfulBackupTime';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountDisplayName",
            "baseName": "accountDisplayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceStorageSizeBytes",
            "baseName": "sourceStorageSizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "eonSnapshotCount",
            "baseName": "eonSnapshotCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "lastSuccessfulBackupTime",
            "baseName": "lastSuccessfulBackupTime",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return ResourceDetails.attributeTypeMap;
    }
    constructor() {
    }
}
